/**
 * @example
 * // returns 'width: 5rem; height: 5rem;'
 * return(<img css={helperSize(50)} alt="" />);
 * @example
 * // returns 'width: 5rem; height: 3rem;'
 * return(<img css={helperSize(50, 30)} alt="" />);
 * @example
 * // returns 'width: 5rem; height: auto;'
 * return(<img css={helperSize(50, 'auto')} alt="" />);
 * @example
 * // returns 'width: 15px; height: 12px;'
 * return(<img css={helperSize('15px', '12px')} alt="" />);
 */

import { css } from '@emotion/react';
import { Media, UnitValue } from '../types';
import { setDeclaration } from '../utils';

type sizeType = UnitValue | Media<UnitValue>;

export const helperSize = (width: sizeType, height?: sizeType) => {
  height = height ?? width;

  return css`
    ${setDeclaration('width', width, 'rem')};
    ${setDeclaration('height', height, 'rem')};
  `;
};
